// automatically generated by the FlatBuffers compiler, do not modify

/* eslint-disable @typescript-eslint/no-unused-vars, @typescript-eslint/no-explicit-any, @typescript-eslint/no-non-null-assertion */

import * as flatbuffers from 'flatbuffers';

import { EscalatorControl } from './escalator-control';


export class EscalatorControlMessage implements flatbuffers.IUnpackableObject<EscalatorControlMessageT> {
  bb: flatbuffers.ByteBuffer|null = null;
  bb_pos = 0;
  __init(i:number, bb:flatbuffers.ByteBuffer):EscalatorControlMessage {
  this.bb_pos = i;
  this.bb = bb;
  return this;
}

static getRootAsEscalatorControlMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorControlMessage):EscalatorControlMessage {
  return (obj || new EscalatorControlMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

static getSizePrefixedRootAsEscalatorControlMessage(bb:flatbuffers.ByteBuffer, obj?:EscalatorControlMessage):EscalatorControlMessage {
  bb.setPosition(bb.position() + flatbuffers.SIZE_PREFIX_LENGTH);
  return (obj || new EscalatorControlMessage()).__init(bb.readInt32(bb.position()) + bb.position(), bb);
}

message():EscalatorControl {
  const offset = this.bb!.__offset(this.bb_pos, 4);
  return offset ? this.bb!.readUint16(this.bb_pos + offset) : EscalatorControl.RunUp;
}

static startEscalatorControlMessage(builder:flatbuffers.Builder) {
  builder.startObject(1);
}

static addMessage(builder:flatbuffers.Builder, message:EscalatorControl) {
  builder.addFieldInt16(0, message, EscalatorControl.RunUp);
}

static endEscalatorControlMessage(builder:flatbuffers.Builder):flatbuffers.Offset {
  const offset = builder.endObject();
  return offset;
}

static createEscalatorControlMessage(builder:flatbuffers.Builder, message:EscalatorControl):flatbuffers.Offset {
  EscalatorControlMessage.startEscalatorControlMessage(builder);
  EscalatorControlMessage.addMessage(builder, message);
  return EscalatorControlMessage.endEscalatorControlMessage(builder);
}

unpack(): EscalatorControlMessageT {
  return new EscalatorControlMessageT(
    this.message()
  );
}


unpackTo(_o: EscalatorControlMessageT): void {
  _o.message = this.message();
}
}

export class EscalatorControlMessageT implements flatbuffers.IGeneratedObject {
constructor(
  public message: EscalatorControl = EscalatorControl.RunUp
){}


pack(builder:flatbuffers.Builder): flatbuffers.Offset {
  return EscalatorControlMessage.createEscalatorControlMessage(builder,
    this.message
  );
}
}
